import { gql } from '@apollo/client';
import FULL_USER_FRAGMENT from 'graphql/fragments/companyUser/fullCompanyUserFrag';
import FULL_TALENT_FRAGMENT from 'graphql/fragments/talent/fullTalentFragment';

export default gql`
  ${FULL_TALENT_FRAGMENT}
  ${FULL_USER_FRAGMENT}
  query GetCurrentTalent {
    currentTalent {
      ...FullTalent
      number_of_active_matcher_assignments
    }
    currentUserAccounts {
      company_user_accounts {
        ...FullUser
      }
      talent_accounts {
        ...FullTalent
      }
    }
  }
`;
